<template>
  <div class="searchUserPanel">
    <form @submit.prevent="handleSearch()">
      <div
        class="inner-addon left-addon"
        :style="`${customSize ? `max-width: ${customSize}px` : 'test'}`"
      >
        <svg
          class="searchIcon"
          width="40"
          height="35"
          viewBox="0 0 30 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.3" clip-path="url(#clip0)">
            <path
              d="M26.8421 28.9995C26.5263 28.9995 26.2105 28.9995 25.8947 28.9995C25.5947 28.8 25.2474 28.6619 24.9947 28.4164C23.2579 26.7593 21.5368 25.0868 19.8158 23.4143C19.3263 22.954 19.0737 22.3249 19.3263 21.7418C19.6105 21.0974 19.3579 20.7598 18.9158 20.3915C18.6947 20.2074 18.4737 20.0233 18.3 19.7931C17.9211 19.3175 17.6053 19.3175 17.0684 19.655C11.8421 22.9693 4.76842 21.3582 1.56316 16.1566C0.742105 14.837 0.363158 13.3794 0 11.9064C0 11.1392 0 10.3873 0 9.62011C0.0473684 9.42064 0.126316 9.23652 0.157895 9.03704C0.852632 4.63334 4.32632 1.15027 8.92105 0.214293C13.2789 -0.675654 18.0316 1.24234 20.3842 4.95556C22.8316 8.83757 22.7368 12.7503 20.2895 16.6169C20.1474 16.8318 19.8316 17.0312 20.1474 17.3381C20.6368 17.8138 21.1105 18.2741 21.6 18.7497C21.7737 18.9185 21.9158 18.8418 22.1053 18.7804C23.0368 18.4122 23.7632 18.6884 24.4421 19.3482C25.9263 20.8212 27.4421 22.2788 28.9579 23.7212C29.3684 24.1201 29.7316 24.5344 30 25.0407C30 25.3476 30 25.6545 30 25.9614C29.1947 27.2042 28.1368 28.2169 26.8421 28.9995ZM11.0368 18.3815C15.4263 18.3968 18.9632 15.0058 18.9789 10.7556C18.9947 6.5053 15.4895 3.06826 11.1158 3.05292C6.69474 3.03757 3.15789 6.39789 3.12632 10.6482C3.09474 14.9445 6.6 18.3661 11.0368 18.3815Z"
              fill="#090741"
            />
            <path
              d="M15.3001 8.13255C15.2528 8.6389 15.0159 9.06853 14.4949 9.31404C13.9738 9.55954 13.437 9.55954 13.0107 9.20663C11.7001 8.10187 10.4528 8.13255 9.14223 9.22197C8.5896 9.68229 7.78434 9.52885 7.29486 9.0225C6.82118 8.5315 6.7896 7.7643 7.23171 7.21192C8.92118 5.06377 13.358 5.07911 15.0001 7.24261C15.1896 7.50345 15.3001 7.77964 15.3001 8.13255Z"
              fill="#090741"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="30" height="29" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <input
          type="text"
          :placeholder="placeholder || 'Szukaj'"
          style="border-radius: 10px; font-size: 14px"
          class="form-control searchBlock"
          v-model="searchModel"
          @keyup="checkIfEmpty"
          @blur="handleInputBlur"
        />
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: ["placeholder", "defaultValue", "customSize"],
  data() {
    return {
      searchModel: "",
    };
  },
  watch: {
    defaultValue() {
      this.searchModel = this.defaultValue;
    },
    searchModel() {
      this.handleSearchType();
    },
  },
  created() {
    if (this.defaultValue) {
      this.searchModel = this.defaultValue;
    }
  },

  emits: ["search", "inputChange", "onBlur"],

  methods: {
    handleSearch() {
      this.$emit("search", this.searchModel);
    },
    handleSearchType() {
      this.$emit("inputChange", this.searchModel);
    },
    handleInputBlur() {
      this.$emit("onBlur");
    },
    checkIfEmpty() {
      if (this.searchModel === "") this.handleSearch();
    },
  },
};
</script>

<style scoped>
.searchPanel h1 {
  margin-bottom: 0;
  margin-right: 20px;
}
.searchPanel {
  display: flex;
  align-items: center;
  min-height: 80px;
  justify-content: space-between;
}
.searchUserPanel {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.searchUserPanel input {
  border-radius: 8px !important;
  border: 1px solid #090741;
  color: #090741;
  height: 40px;
  font-size: 13px;
}
.inner-addon {
  position: relative;
}

/* style icon */
.inner-addon .searchIcon {
  position: absolute;
  padding: 10px;
  pointer-events: none;
  top: 50%;
  transform: translateY(-50%);
}

/* add padding  */
.left-addon input {
  padding-left: 45px;
}
</style>
